import { Center, Loader } from '@mantine/core';
import { Navigate, Outlet, useLocation } from 'react-router';

import { useAuth } from '../auth/context';

/** Everything except `/login` sits behind this. */
export function RequireAuth() {
  const { token, hydrating } = useAuth();
  const location = useLocation();

  if (!token) {
    // `state.from` is what the login page sends the operator back to, so a
    // bookmarked deep link survives an expired session.
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  }

  if (hydrating) {
    return (
      <Center h="100vh">
        <Loader />
      </Center>
    );
  }

  return <Outlet />;
}
